import { useAddZutatMutation, useListZutatenQuery } from '../zutaten/zutatenConnector';
import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import { Menge } from "../../utils/Menge";
import { Mengenangabe } from "../../utils/Mengenangabe";
import { parseZutatInput, ZutatOptionValue } from "./GerichtComponent";


export function AddZutatComponent(props: { onConfirm: (zutatId: number, menge: Mengenangabe) => void; }) {
    const { data: zutaten, isLoading, isError } = useListZutatenQuery();
    const [addNewZutat] = useAddZutatMutation();
    const [text, setText] = React.useState("");

    if (!zutaten) {
        if (isLoading)
            return <>Loading...</>;
        if (isError)
            return <>Error</>;
        return <>(n/a)</>;
    }
    return <>
        <div style={{ width: "20em" }}>
            <Autocomplete
                autoHighlight
                inputValue={text}
                onInputChange={(e, newValue, reason) => reason === "reset" ? setText("") : setText(newValue ?? "")}
                filterOptions={(options, params) => {
                    const { zutatName, menge, einheit } = parseZutatInput(params.inputValue);

                    const searchString = zutatName.toLowerCase();
                    const filtered = options
                        .filter(x => x.type === "zutat" && x.zutat.name.toLowerCase().includes(searchString))
                        .map(x => ({ ...x, menge, einheit }));
                    if (zutatName !== "") {
                        filtered.push({ type: "neueZutat", zutatName, menge, einheit });
                    }
                    return filtered;
                }}
                renderOption={(props, option) => <Box component="li" {...props}>
                    <Menge {...option} />&nbsp;
                    {option.type === "neueZutat" ?
                        <i>Neue Zutat: {option.zutatName}</i> :
                        <>{option.zutat.name}</>}
                </Box>}
                value={null}
                onChange={async (e, newValue) => {
                    if (!newValue)
                        return;
                    if (newValue.type === "zutat") {
                        const { zutat, menge, einheit } = newValue;
                        props.onConfirm(zutat.id, { menge, einheit });
                    }
                    else {
                        const { zutatName, menge, einheit } = newValue;
                        if (!window.confirm(`Sicher, dass die folgende Zutat angelegt werden soll?\n\n${zutatName}`))
                            return;
                        const result = await addNewZutat(zutatName);
                        if ("error" in result) {
                            window.alert(`Fehler beim Hinzufügen der Zutat: ${JSON.stringify(result.error)}`);
                            return;
                        }
                        props.onConfirm(result.data.id, { menge, einheit });
                    }
                    setText("");
                }}
                renderInput={params => <TextField
                    {...params}
                    label="Zutat hinzufügen" />}
                options={zutaten.map((zutat): ZutatOptionValue => ({ type: "zutat", zutat, einheit: "stueck", menge: 1 }))}
                getOptionLabel={option => option.type === "neueZutat" ? "neueZutat" : option.zutat.id.toString()} />
        </div>
    </>;
}
